import script from "./backhead.vue?vue&type=script&setup=true&lang=js"
export * from "./backhead.vue?vue&type=script&setup=true&lang=js"

import "./backhead.vue?vue&type=style&index=0&id=6c50159b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c50159b"]])

export default __exports__